/*
 * hearo — Delivery Estimate
 *
 * Reads data-hearo-delivery-min / -max from the snippet and injects a
 * formatted date range into [data-hearo-delivery-window]. Skips
 * weekends AND US federal holidays.
 *
 * Re-computes on:
 *   - DOMContentLoaded
 *   - Dawn's PUB_SUB_EVENTS.cartUpdate (cart changes)
 *   - MutationObserver on the cart drawer (section re-render)
 *
 * No deps. All US holidays are calendared; update yearly.
 * Author: BB Brands · 2026-04-17
 */

(function () {
  'use strict';

  var WEEKDAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTH_NAMES = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  /* US Federal Holidays — UPS/USPS/FedEx non-delivery days.
     Observed date (shipping cutoff) is what matters, not statutory date. */
  var US_HOLIDAYS = [
    // 2026
    '2026-01-01', '2026-01-19', '2026-02-16', '2026-05-25',
    '2026-06-19', '2026-07-03', '2026-09-07', '2026-10-12',
    '2026-11-11', '2026-11-26', '2026-12-25',
    // 2027
    '2027-01-01', '2027-01-18', '2027-02-15', '2027-05-31',
    '2027-06-18', '2027-07-05', '2027-09-06', '2027-10-11',
    '2027-11-11', '2027-11-25', '2027-12-24',
    // 2028
    '2028-01-17', '2028-02-21', '2028-05-29', '2028-06-19',
    '2028-07-04', '2028-09-04', '2028-10-09', '2028-11-10',
    '2028-11-23', '2028-12-25'
  ];

  function toISODate(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  function isNonDeliveryDay(date) {
    var day = date.getDay();
    if (day === 0 || day === 6) return true;
    return US_HOLIDAYS.indexOf(toISODate(date)) !== -1;
  }

  function addBusinessDays(date, days) {
    var result = new Date(date);
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (!isNonDeliveryDay(result)) added++;
    }
    return result;
  }

  function formatShortDate(date) {
    return WEEKDAY_NAMES[date.getDay()] + ', ' +
      MONTH_NAMES[date.getMonth()] + ' ' +
      date.getDate();
  }

  function sameDay(a, b) {
    return a.getFullYear() === b.getFullYear()
      && a.getMonth() === b.getMonth()
      && a.getDate() === b.getDate();
  }

  function computeWindow(minDays, maxDays) {
    var now = new Date();
    var minDate = addBusinessDays(now, minDays);
    var maxDate = addBusinessDays(now, maxDays);
    if (sameDay(minDate, maxDate)) {
      return formatShortDate(minDate);
    }
    return formatShortDate(minDate) + ' – ' + formatShortDate(maxDate);
  }

  function apply(root) {
    if (!root) return;
    var nodes = root.querySelectorAll('[data-hearo-delivery]');
    nodes.forEach(function (node) {
      var minDays = parseInt(node.getAttribute('data-hearo-delivery-min'), 10);
      var maxDays = parseInt(node.getAttribute('data-hearo-delivery-max'), 10);
      if (isNaN(minDays) || minDays < 1) minDays = 1;
      if (isNaN(maxDays) || maxDays < minDays) maxDays = minDays;
      var label = computeWindow(minDays, maxDays);
      var target = node.querySelector('[data-hearo-delivery-window]');
      if (target) target.textContent = label;
    });
  }

  function applyAll() {
    apply(document);
  }

  /* Boot */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }

  /* Re-compute after Dawn's Section Rendering API replaces innerHTML.
     Defer with rAF so it runs after Dawn's own .open() / focus-trap. */
  var observer = new MutationObserver(function (mutations) {
    var needs = false;
    mutations.forEach(function (m) {
      if (m.addedNodes && m.addedNodes.length) needs = true;
    });
    if (needs) {
      requestAnimationFrame(applyAll);
    }
  });

  function startObserving() {
    var drawers = document.querySelectorAll('cart-drawer');
    drawers.forEach(function (drawer) {
      observer.observe(drawer, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }

  /* Expose small API */
  window.hearoDelivery = {
    apply: applyAll,
    compute: computeWindow
  };
})();
